import * as Factory from 'factory.ts'
import faker from 'faker'

import { type PurchaseOrderWithUnreceivedItems } from '@webapp/models'

export const PurchaseOrderWithUnreceivedItemsMock =
  Factory.Sync.makeFactory<PurchaseOrderWithUnreceivedItems>({
    id: Factory.each(() => faker.random.number()),
    number: '',
    has_unbilled_unreceived_items: true,
    items: [],
  }).withDerivation1(['id'], 'number', (id) => `PF${id}`)
